import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getAmplifyClient } from '@/services/amplifyClient'
import {
  createPlaceMutation,
  deletePlaceMutation,
  updatePlaceMutation,
} from '@/services/graphql/mutations'

const client = getAmplifyClient()

export const useCreatePlace = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['createPlace'],
    mutationFn: createPlace,
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ['places'],
      })
    },
  })
}

export const useUpdatePlace = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['updatePlace'],
    mutationFn: updatePlace,
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ['places'],
      })
    },
  })
}

export const useDeletePlace = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['deletePlace'],
    mutationFn: deletePlace,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['places'],
      })
    },
  })
}

export const createPlace = async (id) => {
  await client.graphql({
    query: createPlaceMutation,
    variables: { input: id },
  })
}

export const updatePlace = async (input) => {
  await client.graphql({
    query: updatePlaceMutation,
    variables: { input },
  })
}

export const deletePlace = async (id) => {
  await client.graphql({
    query: deletePlaceMutation,
    variables: { id },
  })
}
